import { useEffect, useState } from "react";
import { useAuthContext } from "./useAuthContext";
import { useSettingsContext } from "./useSettingsContext";
import axios from 'axios';

export const useAssessment = () => {

    const { username, user, clientApi, dispatch: authDispatch } = useAuthContext();
    const { isWinAuth } = useSettingsContext();
    const [isLoading, setIsLoading] = useState(true);

    const questionLineTypeToIndex = [
        { label: "Text", value: 2 },
        { label: "Slider", value: 21 },
        { label: "Essay", value: 6 },
        { label: "Scale", value: 5 },
        { label: "Scale With n/a", value: 12 },
        { label: "Boxes", value: 23 },
        { label: "TCC", value: 10 },
    ];
    useEffect(() => {
    }, [])

    const axiosInstance = axios.create({
        baseURL: `${clientApi}`,
        headers: {
            accepts: "application/json",
            "Content-Type": "application/json",
        },
    });

    axiosInstance.interceptors.request.use(request => {
        // console.log('Set Bearer Token')
        const accessToken = user.token;
        if (accessToken) {
            request.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return request;
    }, error => {
        return Promise.reject(error);
    });

    axiosInstance.interceptors.response.use(
        response => response, // Directly return successful responses.
        async error => {
            console.log('Refresh Access Token Expired!!!')
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
                try {
                    if (!isWinAuth) {
                        // Make a request to your auth server to refresh the token.
                        const response = await axiosInstance.post(`${clientApi}api/auth/refresh`, user);
                        // Store the new access and refresh tokens.
                        authDispatch({ type: 'Refresh', payload: response.data, clientApi: clientApi, username: username });

                        // Update the authorization header with the new access token.
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                    }
                    else {
                        const newToken = await acquireSilentToken();
                        let tmpUser = user;
                        tmpUser.token = newToken;
                        authDispatch({ type: 'REFRESH', payload: tmpUser, clientApi: clientApi, username: username });
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                    }
                    return axios(originalRequest); // Retry the original request with the new access token.
                } catch (refreshError) {
                    // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
                    console.error('Token refresh failed:', refreshError);
                    authDispatch({ type: 'LOGOUT' });
                    return Promise.reject(refreshError);
                }
            }
            return Promise.reject(error); // For all other errors, return the error as is.
        }
    );

    const loadAssessment = async (
        server_ip,
        token,
        username,
        employeeId,
        assmEmplUi,
        cType,
        AssmType
    ) => {
        try {
            setIsLoading(true)
            let Stage;
            switch (cType) {
                case 'Appraisee':
                    Stage = '1';
                    break;
                case 'Appraiser':
                    Stage = '2';
                    break;
                case 'Meeting':
                    Stage = '3';
                    break;
                default:
                    Stage = '4';
            }

            const cAssm = {
                employeeId: employeeId,
                assmEmplUi: assmEmplUi,
                StageText: "",
                Stage: Stage,
                AssmType: AssmType,
                AnswersToShow: null,
                isSubmitted: false,
            };

            const fetchCmd = `${server_ip}api/assessments/LoadUserAssessmentPage`;
            const response = await axiosInstance.post(fetchCmd, cAssm, {
                params: {
                    username: username,
                },
            });
            // console.log(response.data)
            setIsLoading(false)
            return response.data;
        } catch (error) {
            console.error("There was an error!", error);
            setIsLoading(false)
            return false;
        }
    }

    const loadUserAssessments = async (
        server_ip,
        token,
        username,
        employeeId
    ) => {
        try {
            setIsLoading(true)
            var fetchCmd = server_ip + "api/assessments/AssessmentsHomeUser";
            const response = await axiosInstance.get(fetchCmd, {
                params: { username: username, userid: employeeId },
            })
            setIsLoading(false)
            return response.data;

        } catch (error) {
            // console.log(error);
            return [];
        } finally {
            setIsLoading(false)

        }
    }

    const getAssmDetails = async (server_ip, token, username, employeeId) => {
        try {
            const data = {
                employeeId: employeeId,
                assmEmplUi: "009D6553-CF3C-472A-ADF7-77FE3ECF2DA9",
                StageText: "1",
                AssmType: " ",
                AnswersToShow: null,
                isSubmitted: false,
            };

            const fetchCmd = `${server_ip}api/assessments/LoadUserAssessmentPage`;
            const response = await axiosInstance.post(fetchCmd, data, {
                params: {
                    username: username,
                },
            });
            return true;
        } catch (error) {
            console.error("There was an error!", error);
            return false;
        }
    }

    const loadEveryAssessment = async (server_ip, token, username) => {
        try {
            var fetchCmd = server_ip + "api/Assessments/AssessmentsHomeAdmin";
            const response = await axiosInstance.get(fetchCmd, {

                params: { username: username },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const loadEveryEmployee = async (server_ip, token, username) => {
        try {
            var fetchCmd =
                server_ip + "api/Assessments/AssessmentsHomeAdmin/GetEmployees";
            const response = await axiosInstance.get(fetchCmd, {
                params: { username: username },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const loadParticipants = async (assmId) => {
        setIsLoading(true);
        const id = assmId.toUpperCase();
        let resp = [];
        var fetchCmd =
            `${clientApi}api/Assessments/AssessmentsHomeAdmin/GetAssmParts`;
        await axiosInstance.get(fetchCmd, {
            params: { username: username, assmUi: id },
        }).then((response) => {
            setIsLoading(false);
            resp = response.data;
        }).catch((error) => {
            console.log(error);
        })
        return resp;
    }
    const loadResultResponses = async (server_ip, token, username, assmId) => {
        setIsLoading(true);
        const id = assmId.toUpperCase();
        let resp = [];
        var fetchCmd = `${clientApi}api/Assessments/AssessmentsHomeAdmin/GetResponsesForAssessment`;
        await axiosInstance.get(fetchCmd, {
            params: { username: username, assmUi: id },
        }).then((response) => {
            response.data.map((resItr) => {
                let converted = ConvertResponses(resItr)
                resp.push(converted)
            })
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            console.log(error);
            resp = [];
        })
        return resp;

    }

    const GetRawData = async (assmId) => {
        setIsLoading(true);
        const id = assmId.toUpperCase();
        let resp = [];
        var fetchCmd = `${clientApi}api/Assessments/AssessmentsHomeAdmin/RawResults`;
        await axiosInstance.get(fetchCmd, {
            params: { username: username, assmUi: id },
        }).then((response) => {
            const { fileContents, contentType, fileDownloadName } = response.data;
            // Converting base64 string (fileContents) to binary data (ArrayBuffer)
            const byteCharacters = atob(fileContents);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // Convert ArrayBuffer to Blob (binary large obj)
            const blob = new Blob([byteArray], { type: contentType });

            // Create a download link for the Blob
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileDownloadName);
            document.body.appendChild(link);
            link.click();
            setIsLoading(false);
            resp = response.data;
        }).catch((error) => {
            setIsLoading(false);
            console.log(error);
        })
        return resp;
    }

    const loadAssessmentByUI = async (server_ip, token, username, assmUi) => {
        try {
            const id = assmUi.toUpperCase();
            //console.log(id)
            var fetchCmd =
                server_ip + "api/Assessments/AssessmentsHomeAdmin/GetAssessment";
            const response = await axiosInstance.get(fetchCmd, {
                params: {
                    username: username,
                    assmUi: id,
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const DeleteAssm = async (server_ip, token, username, assmUi) => {
        try {
            setIsLoading(true)
            const id = assmUi.toUpperCase();
            var fetchCmd =
                server_ip + "api/Assessments/AssessmentsHomeAdmin/DeleteAssm";
            const response = await axiosInstance.get(fetchCmd, {
                params: {
                    username: username,
                    assmUi: id,
                },
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            return [];
        }
    }

    const removeQuestionLineFromUI = async (server_ip, token, username, questionLineUI) => {
        try {
            setIsLoading(true)
            const id = questionLineUI.toUpperCase();
            var fetchCmd =
                server_ip + "api/Assessments/AssessmentsHomeAdmin/DeleteQuestionLine";
            const response = await axiosInstance.get(fetchCmd, {
                params: {
                    username: username,
                    questionLineUI: id,
                },
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error);
            return [];
        }
    }

    const removeQuestionFromUI = async (server_ip, token, username, questionUI) => {
        try {
            const id = questionUI.toUpperCase();
            var fetchCmd =
                server_ip + "api/Assessments/AssessmentsHomeAdmin/DeleteQuestion";
            const response = await axiosInstance.get(fetchCmd, {
                params: {
                    username: username,
                    questionUI: id,
                },
            });
            //console.log(response.data)
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const removeSectionFromUI = async (server_ip, token, username, sectionUI) => {
        try {
            const id = sectionUI.toUpperCase();
            var fetchCmd =
                server_ip + "api/Assessments/AssessmentsHomeAdmin/DeleteSection";
            const response = await axiosInstance.get(fetchCmd, {
                params: {
                    username: username,
                    sectionUI: id,
                },
            });
            //console.log(response.data)
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const deleteParticipant = async (server_ip, token, username, assmEmplUI) => {
        try {
            const id = assmEmplUI.toUpperCase();
            var fetchCmd =
                server_ip + "api/Assessments/AssessmentsHomeAdmin/DeleteParticipations";
            const response = await axiosInstance.get(fetchCmd, {
                params: {
                    username: username,
                    assmEmplUI: id,
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const GetResults = async (server_ip, token, username, assmUi) => {
        setIsLoading(true);
        const id = assmUi.toUpperCase();
        let resp = []
        var fetchCmd =
            `${clientApi}api/Assessments/AssessmentsHomeAdmin/AssmStatus`;
        await axiosInstance.get(fetchCmd, {
            params: {
                username: username,
                assmUi: id,
            },
        }).then((response) => {
            setIsLoading(false);
            resp = response.data;
        }).catch((error) => {
            setIsLoading(false);
            console.log(error);
        })
        return resp;
    }

    const loadGroupById = async (server_ip, token, username, id) => {
        try {
            var fetchCmd =
                server_ip + "api/assessments/AssessmentsHomeAdmin/GetAssmGroup";
            const response = await axiosInstance.get(fetchCmd, {
                params: { username: username, AssmGroupUi: id },
            });
            return response.data[0];
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const DeleteGroup = async (server_ip, token, username, id) => {
        try {
            var fetchCmd =
                server_ip + "api/assessments/AssessmentsHomeAdmin/DeleteGroup";
            const response = await axiosInstance.get(fetchCmd, {
                params: { username: username, assmgroupUI: id },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const loadGroups = async (server_ip, token, username) => {
        try {
            var fetchCmd = server_ip + "api/assessments/AssessmentsGroupHome";
            const response = await axiosInstance.get(fetchCmd, {
                params: { username: username },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const loadCompany = async (server_ip, token, username) => {
        try {
            var fetchCmd = server_ip + "api/assessments/AssessmentsCompany";
            const response = await axiosInstance.get(fetchCmd, {
                params: { username: username },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const loadWorkflow = async (server_ip, token, username) => {
        try {
            var fetchCmd = server_ip + "api/assessments/AssessmentsWorkFlows";
            const response = await axiosInstance.get(fetchCmd, {
                params: { username: username },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const loadQuestionTypes = async (server_ip, token, username) => {
        try {
            var fetchCmd =
                server_ip +
                "api/assessments/AssessmentsHomeAdmin/AssessmentQuestLineTypes";
            const response = await axiosInstance.get(fetchCmd, {
                params: { username: username },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const postGroup = async (server_ip, token, group, employeeId) => {
        var data = {
            GroupTitle: group.description,
            Locked: group.locked,
            assmgroupUI: group.assmgroupUI,
            userid: employeeId,
            Assessments: [],
        };

        var fetchCmd =
            server_ip + "api/assessments/AssessmentsHomeAdmin/SaveAssmGroup";
        await axiosInstance
            .post(
                fetchCmd,
                {
                    ...data,
                },
            )
            .then((response) => {
                return true;
            })
            .catch((error) => {
                console.error("There was an error!", error);
                return error;
            });
    }

    const postAssessment = async (
        server_ip,
        token,
        assm,
        sectionQuestionList,
        username,
        employeeId
    ) => {
        try {
            setIsLoading(true)
            let res = false;
            var Assessment = {
                assmUi: assm.id,
                description: assm.assm_title,
                assmGroupUi: assm.assm_group_id,
                assmFromDate: assm.assm_from_date,
                assmToDate: assm.assm_to_date,
                allowChangeOfAppraiser: assm.assm_allowChangeOfAppraiser,
                instructions: assm.assm_instructions,
                assmType: assm.assm_type,
                assmCompany: assm.assm_company,
                userid: employeeId,
                AssmSect: [],
            };

            for (var i = 0; i < sectionQuestionList.length; i++) {
                var sectionData = {
                    sectionUi: sectionQuestionList[i].id,
                    assmUi: assm.id,
                    sectionId: sectionQuestionList[i].section_order,
                    description: sectionQuestionList[i].section_name,
                    isQuantitative: sectionQuestionList[i].section_quantitative,
                    userid: employeeId,
                    hideMeetingComparison: sectionQuestionList[i].section_hideComparison,
                    readOnlyToWhom: sectionQuestionList[i].section_rotw ? sectionQuestionList[i].section_rotw : sectionQuestionList[i].section_rot ? sectionQuestionList[i].section_rot : "",
                    instructions: sectionQuestionList[i].section_instructions,
                    setctionImgUrl: sectionQuestionList[i].section_url_img,
                    isSectionCover: sectionQuestionList[i].isSectionCover,
                    graphAxis: sectionQuestionList[i].graphAxis,
                    useOnGraph: sectionQuestionList[i].useOnGraph,
                    weight: sectionQuestionList[i].section_weight,
                    isResult: sectionQuestionList[i].section_showResults,
                    AssmQuest: [],
                };
                // * If it is Section Cover do not save any question 
                if (!sectionData.isSectionCover)
                    for (var j = 0; j < sectionQuestionList[i].section_questions.length; j++) {
                        console.log()
                        var questionData = {
                            questUI: sectionQuestionList[i].section_questions[j].id,
                            sectionUI: sectionQuestionList[i].section_questions[j].assm_section_id,
                            description: sectionQuestionList[i].section_questions[j].question_name,
                            questId: sectionQuestionList[i].section_questions[j].question_order,
                            assmQuestLineTypeId: questionLineTypeToIndex.find((item) => item.label === sectionQuestionList[i].section_questions[j].input_type_name)?.value,
                            value: 0,
                            instructions: sectionQuestionList[i].section_questions[j].quest_instructions,
                            sums: false,
                            weight: sectionQuestionList[i].section_questions[j].question_weight,
                            questImgUrl: sectionQuestionList[i].section_questions[j].questImgUrl,
                            isQuestionCover: sectionQuestionList[i].section_questions[j].isQuestionCover,
                            isRequired: sectionQuestionList[i].section_questions[j].question_required_yn === undefined ?
                                false : sectionQuestionList[i].section_questions[j].question_required_yn === 1 ? true : false,
                            userId: employeeId,
                            isResult: false,
                            assmQuestLine: [],
                        };
                        if (!questionData.isQuestionCover) {
                            let sum = 0;
                            for (var k = 0; k < sectionQuestionList[i].section_questions[j].question_lines.length; k++) {
                                var questionLineData = {
                                    questLineUI: sectionQuestionList[i].section_questions[j].question_lines[k].id,
                                    questUI: sectionQuestionList[i].section_questions[j].id,
                                    lineId: sectionQuestionList[i].section_questions[j].question_lines[k].question_line_order,
                                    description: sectionQuestionList[i].section_questions[j].question_lines[k].question_line_description,
                                    assmQuestLineTypeId: questionLineTypeToIndex.find((item) => item.label === sectionQuestionList[i].section_questions[j].question_lines[k].input_type_name)?.value,
                                    userid: employeeId,
                                    instructions: "",
                                    defaultValue: "",
                                    valuelist: "",
                                    colour: "",
                                };
                                sum = sum + sectionQuestionList[i].section_questions[j].question_lines[k].weight;
                                questionData.assmQuestLine.push(questionLineData);
                            }
                        }
                        sectionData.AssmQuest.push(questionData);
                    }
                Assessment.AssmSect.push(sectionData);
            }
            console.log(Assessment)
            var postCmd = server_ip + "api/assessments/AssessmentsHomeAdmin/SaveAssm";
            await axiosInstance
                .post(postCmd, Assessment, {
                    params: {
                        username: username,
                    },
                })
                .then((response) => {
                    setIsLoading(false)
                    res = (response.status === 200);
                });
            return res;
        } catch (error) {
            console.error("There was an error!", error);
            setIsLoading(false)
        }

    }

    const SaveAssmInfo = async (
        server_ip,
        token,
        assm,
        username,
        employeeId
    ) => {
        try {
            var Assessment = {
                assmUi: assm.id,
                description: assm.assm_title,
                assmGroupUi: assm.assm_group_id,
                assmFromDate: assm.assm_from_date,
                assmToDate: assm.assm_to_date,
                allowChangeOfAppraiser: assm.assm_allowChangeOfAppraiser,
                instructions: assm.assm_instructions,
                assmType: assm.assm_type,
                assmCompany: assm.assm_company,
                userid: employeeId,
                AssmSect: [],
            };
            console.log(Assessment)

            var fetchCmd = server_ip + "api/assessments/AssessmentsHomeAdmin/SaveAssmInfo";
            await axiosInstance
                .post(fetchCmd, Assessment, {
                    params: {
                        username: username,
                    },
                })
                .then((response) => {
                    return true;
                });
        } catch (error) {
            console.error("There was an error!", error);
            return error;
        }
    }

    const saveUserAssm = async (server_ip, token, username, employeeId) => {
        try {
            const data = {
                employeeId: employeeId,
                assmEmplUi: "31D51105-09AD-4683-8F04-A190EE56EC73",
                StageText: "Acceptance",
                Stage: "1",
                AssmType: "",
                AnswersToShow: null,
                isSubmitted: false,
                resp: [
                    {
                        respUi: "0E9A7FA6-564E-EF11-B664-00155D0C01EB",
                        resp: "Someone else",
                    },
                ],
            };

            const fetchCmd = `${server_ip}api/assessments/LoadUserAssessmentPage`;
            const response = await axiosInstance.post(fetchCmd, data, {
                params: {
                    username: username,
                },
            });

            return true;
        } catch (error) {
            console.error("There was an error!", error);
            return false;
        }
    }

    const postParticipant = async (server_ip, token, partList, username, employeeId) => {
        try {
            //console.log(partList)
            var fetchCmd = server_ip + "api/assessments/AssessmentsHomeAdmin/SaveAssm/Participations";
            await axiosInstance
                .post(fetchCmd, partList, {
                    params: {
                        username: username,
                    },
                })
                .then((response) => {
                    return true;
                });
        } catch (error) {
            console.error("There was an error!", error);
            return error;
        }
    }

    const updateAssessmentResponse = async (server_ip, username, employeeId, assmUI, Assessment, saveFlag) => {
        try {
            var ResponseModel = [];
            var err = false;
            var errMessage = "";

            Assessment.sectionQuestionList.map((section) => {
                section.section_questions.map((question) => {
                    // Check if question is required and if response is missing or empty
                    if (question.quest_isRequired) {
                        var hasResponse = question.question_lines.some(qLine => {
                            return qLine.question_line_resp !== null && qLine.question_line_resp.toString().trim() !== "";
                        });
                        if (!hasResponse) {
                            err = true;
                            errMessage = 'Required';
                        }
                    }

                    question.question_lines.map((questionLine) => {
                        ResponseModel.push({
                            questUI: questionLine.question_line_questUI,
                            questLineUI: questionLine.id,
                            respUi: questionLine.question_line_respUI,
                            resp: questionLine.question_line_resp ? questionLine.question_line_resp.toString() : "",
                            hasAssmResp: questionLine.has_assmresp === 0 ? false : true,
                        });
                    });
                });
            });

            if (err) {
                return errMessage;
            }
            var cAssmModel = {
                employeeId: employeeId,
                assmEmplUi: Assessment.assm_emplUI,
                Stage: 0,
                StageText: "Acceptance",
                AssmType: null,
                AnswersToShow: null,
                isSubmitted: false,
                resp: ResponseModel,
            };

            console.log(cAssmModel)
            var fetchCmd = saveFlag ? (server_ip + "api/assessments/SaveAssessment") : (server_ip + "api/assessments/SubmitAssessment");
            const resp = await axiosInstance
                .post(fetchCmd, cAssmModel, {
                    params: {
                        username: username,
                    },
                })
                .then((response) => {
                    return response;
                });
            return resp;
        } catch (error) {
            console.error("There was an error!", error);
            return error;
        }

    }

    const ToggleActive = async (server_ip, token, username, assmEmplUi) => {
        try {
            const assmEmplUI = assmEmplUi.toUpperCase();
            var fetchCmd = server_ip + "api/assessments/AssessmentsHomeAdmin/ToggleActive";
            await axiosInstance
                .get(fetchCmd, {
                    params: {
                        username: username,
                        assmEmplUI: assmEmplUI,
                    },
                },)
                .then((response) => {
                    return true;
                });
        } catch (error) {
            console.error("There was an error!", error);
            return error;
        }
    }

    const ToggleSubmit = async (server_ip, token, username, assmEmplUi) => {
        try {
            const assmEmplUI = assmEmplUi.toUpperCase()
            var fetchCmd = server_ip + "api/assessments/AssessmentsHomeAdmin/ToggleSubmit";
            await axiosInstance
                .get(fetchCmd, {

                    params: {
                        username: username,
                        assmEmplUI: assmEmplUI,
                    },
                })
                .then((response) => {
                    return true;
                });
        } catch (error) {
            console.error("There was an error!", error);
            return error;
        }
    }

    const CopyAssmPart = async (server_ip, token, username, fromassmUi, toassmUi) => {
        try {
            const assmFrom = fromassmUi.toUpperCase()
            const assmTo = toassmUi.toUpperCase()
            const assmObj = {
                assmFrom: assmFrom,
                assmTo: assmTo,
            }

            var fetchCmd = server_ip + "api/assessments/AssessmentsHomeAdmin/CopyPartAssm";
            await axiosInstance
                .post(fetchCmd, assmObj, {
                    params: {
                        username: username,
                    },
                })
                .then((response) => {
                    return true;
                });
        } catch (error) {
            console.error("There was an error!", error);
            return error;
        }
    }

    const CopyAssm = async (server_ip, token, username, fromassmUi, toassmUi) => {
        const assmFrom = fromassmUi.toUpperCase()
        const assmTo = toassmUi.toUpperCase()
        const assmObj = {
            assmFrom: assmFrom,
            assmTo: assmTo,
        }
        console.log(assmObj)
        var fetchCmd = server_ip + "api/assessments/AssessmentsHomeAdmin/CopyAssm";
        try {
            await axiosInstance
                .post(fetchCmd, assmObj, {
                    params: {
                        username: username,
                    },
                })
                .then((response) => {
                    return true;
                });
        } catch (error) {
            console.error("There was an error!", error);
            return error;
        }
    }

    // * Convert Responses from the old system to Custom Assessment Variables. 
    const ConvertResponses = (userData) => {
        const assmArray = userData.map((assmData) => ({
            assm_emplUI: assmData.assmEmplUi,
            id: assmData.assmUi,
            assm_group_id: "",
            organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625",
            assm_title: assmData.description,
            assm_instructions: assmData.instructions,
            assm_from_date: assmData.assmFromDate,
            assm_to_date: assmData.assmToDate,
            assm_allowChangeOfAppraiser: assmData.allowChangeOfAppraiser,
            assm_type: assmData.assmType,
            assm_company: assmData.assmCompany,
            assm_appraiser: assmData.name,
            assm_appraisee: assmData.appraisee,
            assm_stage: assmData.stage,
            assm_submitted: assmData.submitted === "SUBMITTED" ? true : false,
            require_login: true,
            sectionQuestionList: assmData.assmSect.map((Section) => ({
                id: Section.sectionUi,
                assm_header_id: Section.assmUi,
                section_name: Section.description,
                section_instructions: Section.instructions,
                section_url_img: Section.section_url_img,
                isSectionCover: Section.isSectionCover,
                useOnGraph: Section.useOnGraph,
                graphAxis: Section.graphAxis,
                section_quantitative: Section.isQuantitative,
                section_showResults: Section.isResult,
                section_hideComparison: Section.hideMeetingComparison,
                section_rotw: "",
                section_weight: Section.weight,
                section_order: Section.sectionId,
                section_questions: Section.assmQuest.map((Question) => ({
                    id: Question.questUI,
                    parent_id: Question.sectionUI,
                    quest_id: Question.questId,
                    question_name: Question.description,
                    question_weight: Question.weight,
                    quest_instructions: Question.instructions,
                    quest_sums: Question.sums,
                    quest_value: Question.value,
                    quest_isResult: Question.isResult,
                    quest_isRequired: Question.isRequired,
                    quest_controls: Question.controls,
                    question_lines: Question.assmQuestLine.map((QuestionLine) => ({
                        id: QuestionLine.questLineUI,
                        question_id: QuestionLine.lineId,
                        question_line_description: QuestionLine.description,
                        question_line_questUI: QuestionLine.questUI,
                        question_line_valuelist: QuestionLine.valuelist,
                        question_line_order: QuestionLine.lineId,
                        question_line_instructions: QuestionLine.instructions,
                        question_line_control: QuestionLine.control,
                        question_line_assm_quest_line_type_id:
                            QuestionLine.assmQuestLineTypeId,
                        question_line_resp: QuestionLine.response,
                        question_line_respUI: QuestionLine.respUI,
                        has_assmresp: 1,
                    })),
                })),
            })),
        }));
        return assmArray
    };

    return {
        loadAssessment, loadAssessmentByUI, loadCompany, loadEveryAssessment, loadEveryEmployee, loadGroupById,
        loadGroups, loadParticipants, loadQuestionTypes, loadUserAssessments, loadWorkflow, getAssmDetails, postAssessment, postGroup, saveUserAssm,
        SaveAssmInfo, postParticipant, updateAssessmentResponse, ToggleActive, ToggleSubmit, CopyAssmPart, CopyAssm, DeleteGroup, DeleteAssm,
        removeSectionFromUI, removeQuestionLineFromUI, removeSectionFromUI, removeQuestionFromUI, GetRawData, GetResults, deleteParticipant,
        loadResultResponses, isLoading
    }
}